import { Injectable } from '@angular/core';
import { UserDto } from '../../../auth/user.dto';
import { Clearances } from '../../../shared/models/enums/clearance.enum';
import { THopayraPermission, TRsjPermission } from '../permissions';

@Injectable({
  providedIn: 'root',
})
export class HopayraPermissionService {
  public getPermissions(user: UserDto): THopayraPermission[] {
    const [group]: string[] = user?.groups;
    switch (group) {
      case 'DIRECTION+':
        return user.clearances?.includes(Clearances.CLR_VALIDATOR_RSJ) ? ['HOPAYRA_CAN_ACCESS'] : [];
      case 'ADMIN':
        return ['HOPAYRA_CAN_ACCESS'];
      default:
        return [];
    }
  }
}
